import api from './axios';

export const adminSubscriptionApi = {
  list: (params = {}) => api.get('/admin/user-subscriptions', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/user-subscriptions/${id}`).then((r) => r.data),
  getTransactions: (id, params = {}) => api.get(`/admin/user-subscriptions/${id}/transactions`, { params }).then((r) => r.data),
  cancel: (id, immediate = false) => api.patch(`/admin/user-subscriptions/${id}/status`, { status: 'canceled', immediate }).then((r) => r.data),
  reactivate: (id) => api.post(`/admin/user-subscriptions/${id}/reactivate`).then((r) => r.data),
  changePlan: (id, planId, immediate = false) => api.put(`/admin/user-subscriptions/${id}/plan`, { planId, immediate }).then((r) => r.data),
  export: (filters = {}) => api.post('/admin/user-subscriptions/export', { filters }).then((r) => r.data),
};
